export enum LocationOverviewType {
  LOCATION_OVERVIEW_ADMIN = 'LOCATION_OVERVIEW_ADMIN',
  LOCATION_OVERVIEW_USER = 'LOCATION_OVERVIEW_USER'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/locationoverviewtype.ts